// @flow
import * as React from "react";
import { Button as RebassButton } from "rebass";
import styled from "styled-components";
import omit from "lodash.omit";

import MiniArrow from "./MiniArrow";

type Props = {
  children: React.Node,
  icon?: React.Node | null,
  loading?: boolean,
  type?: string,
  onClick: () => mixed
};

const propsToOmit = ["loading"];

const Button = (props: Props) => (
  <StyledButton
    px="32px"
    py="14px"
    f={2}
    type={props.type}
    onClick={props.onClick}
    {...omit(propsToOmit)}
  >
    <span className={props.loading ? "loading" : ""}>{props.children}</span>
    {props.icon && !props.loading && <Icon>{props.icon}</Icon>}
  </StyledButton>
);

Button.defaultProps = {
  icon: <MiniArrow fill="#fff" />,
  loading: false
};

export default Button;

Button.defaultProps = {
  type: "button"
};

const StyledButton = styled(RebassButton)`
  -webkit-appearance: none !important;
  background: ${p => p.theme.colors.facebookBlue};
  border: 1px solid rgba(156, 196, 233, 0.31);
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.17);
  border-radius: 4px;
  font-family: "Open Sans";
  color: #ffffff;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  height: 40px;
  letter-spacing: -0.17px;
  line-height: 40px;
  padding: 0 20px;
  text-shadow: 0 1px 1px #22377e;

  &:hover,
  &:visited {
    color: #fff;
  }

  &:active {
    background: ${p => p.theme.colors.base};
    color: #fff;
  }

  &:focus {
    box-shadow: 0px 2px 0 2px #eee;
    color: #fff;
  }

  @media (min-width: 48em) {
    font-size: 14px;
    height: 44px;
    line-height: 44px;
    padding: 0 32px;
  }
`;

const Icon = styled.span`
  display: inline-block;
  margin-left: 10px;
  transform: rotate(-90deg);
`;



// WEBPACK FOOTER //
// ./src/components/ui/Button.jsx